import { css } from '@emotion/react';
import { Theme } from '@mui/material';
import { THEME_MODE } from '@state-mgmt/slices/appSlice';
import { blue } from '@mui/material/colors';

const borderColor = (themeMode: THEME_MODE) => (themeMode === THEME_MODE.DARK ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.12)');

export const styles = {
  container: (themeMode: THEME_MODE) => css`
    width: calc(100vw - 64px);
    height: calc(100vh - 128px);
    position: absolute;
    top: 64px;
    left: 32px;
    overflow-y: auto;
    border-radius: 8px;
    background: ${themeMode === THEME_MODE.DARK ? '#43454b' : '#fff'};
    display: flex;
    flex-direction: column;
  `,
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 20px 16px 12px;
  `,
  demoModeButton: css`
    white-space: nowrap;
    border-radius: 999px;
    text-transform: none;
    font-weight: 600;
    min-width: auto;
  `,
  searchWrap: css`
    padding: 0 16px 10px;
  `,
  search: css`
    & .MuiOutlinedInput-root {
      border-radius: 8px;
      background: transparent;
    }

    & .MuiOutlinedInput-notchedOutline {
      border-width: 1px;
    }

    & .MuiOutlinedInput-input {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  `,
  list: css`
    padding: 0 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  `,
  listItem: (themeMode: THEME_MODE) => css`
    border: 1px solid ${borderColor(themeMode)};
    border-radius: 6px;
    overflow: hidden;
    background: ${themeMode === THEME_MODE.DARK ? 'rgba(255, 255, 255, 0.03)' : '#fff'};
  `,
  selectedItem: (theme: Theme, themeMode: THEME_MODE) => css`
    border-color: ${theme.palette.primary.main};
    background: ${themeMode === THEME_MODE.DARK ? 'rgba(255, 255, 255, 0.06)' : theme.palette.action.hover};
  `,
  listItemButton: css`
    padding: 6px 10px;
    padding-right: 40px;
    min-height: 44px;
  `,
  listItemAvatar: css`
    min-width: 32px;
  `,
  emptyState: css`
    padding: 16px;
  `,
  avatar: css`
    width: 28px;
    height: 28px;
    font-size: 0.85rem;
    background-color: ${blue[100]};
    color: ${blue[600]};
    font-weight: 600;
  `
};
